import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.support.orange.weak};
  border-radius: 16px;
  padding: ${({ theme }) => theme.spacing.km4};
  display: flex;
  gap: ${({ theme }) => theme.spacing.km4};
  align-items: center;
`;

export const TooltipTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  gap: ${({ theme }) => theme.spacing.km1};
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;
